module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("公众号接入")])]), _vm._v(" "), _c('div', {
    staticClass: "p-20 from bor-top-none"
  }, [_c('div', {}, [_c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleAuth
    }
  }, [_vm._v(_vm._s(_vm.publicInfo ? '重新授权公众号' : '立即接入公众号'))])]), _vm._v(" "), (_vm.publicInfo) ? _c('div', {
    staticClass: "p-t-15"
  }, [_c('h5', [_vm._v(_vm._s(_vm.publicInfo.nick_name) + "公众号，已授权皮休管家平台！")]), _vm._v(" "), _vm._m(0)]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-10"
  }, [_c('h6', [_vm._v("皮休管家平台已获得如下权限：")]), _vm._v(" "), _c('ul', {
    staticClass: "m-t-10"
  }, [_c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("消息管理权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("自定义菜单权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("网页服务权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("群发与通知权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("用户管理权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("帐号服务权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("素材管理权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("微信多客服权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("微信小店权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("微信卡券权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("微信门店权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("微信扫一扫权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("微信连WIFI权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("微信摇周边权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("城市服务接口权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("广告管理权限")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-gou p-r-10"
  }), _vm._v("微信电子发票权限")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-e06fe9ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/wechat/WxAuth.vue
// module id = 888
// module chunks = 0